
import { useRef, useState } from "react";
import { FoundationsButton } from "../../GenericComponents/button";
import { PSFS_StatPortalProps, PSFSElement } from "./Psfs_Slice";
declare let window: any
const UnicornApp = window.unicornInstance as any

const TMPScheduling: React.FC<PSFS_StatPortalProps> = ({
    form,
    setForm,
    handleStepStatusAndSave,
    PSFSElements,
    stepManuallyChanged,
    handleStatusResetAndClose,
    handleSave
}) => {
    const formRef = useRef<HTMLFormElement>(null);
    const [isCustomerSite] = useState<boolean>(UnicornApp.checkUserPrivileges("NTSPAdmin"))

    // Check if this step is already completed (form has moved past this step)
    const currentStepNo = PSFSElements?.PSFSStep?.find(step => step.ETLMatchValue === "TMPScheduling")?.StepNo ?? 1;
    const isStepCompleted = !stepManuallyChanged && form.fk_Step !== undefined && form.fk_Step !== -1 && form.fk_Step > currentStepNo;

    // Generic change handler for all fields
    const handleChange = (
        e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>
    ) => {
        const { name, value } = e.target;
        const nextValue = name === "SerialNumber"
        ? value.replace(/\s+/g, "") // remove all spaces
        : value;
        setForm(prev => ({
            ...prev,
            [name]: nextValue
        }));
    };

    return (
        <>
            <form
                className="psfs-form-container"
                ref={formRef}
            >
                <div className="psfs-container mb-1">
                    <div className="first-child mb-4">
                        <label className="psfs-main-label">TMP Scheduling</label>
                        <div className="form-group mt-2">
                            <p style={{ lineHeight: "2.2" }}>
                                <label style={{ lineHeight: "1.5" }}>
                                    Do not complete this section until Serial Number Received from Tablet Team.<br />
                                    Confirm device SN has uploaded to veteran's TMP entry. Then:
                                </label>
                                <br />
                                1. Enter email address as DeviceSN@va.gov (Replace 'DeviceSN' with ACTUAL SN)<br />
                                2. Set Emails to "Allow"<br />
                                3. Click Save, then Refresh entire Page<br />
                                4. Set device type to "VA Issued iPad"
                            </p>
                        </div>
                        <div className="form-group mt-3">
                            <label htmlFor="SerialNumber">iPad serial number</label>
                            <span>
                                <input
                                    type="text"
                                    className="psfs-fields"
                                    id="SerialNumber"
                                    name="SerialNumber"
                                    value={String(form.SerialNumber)}
                                    onChange={handleChange}
                                    tabIndex={1}
                                    maxLength={12}
                                />
                            </span>
                        </div>
                        <div className="form-group mt-3">
                            <label htmlFor="RemoveReserveInTMP">
                                Remove reserve resource and <br />
                                schedule in TMP
                            </label>
                            <span>
                                <select
                                    className="psfs-fields"
                                    id="fk_RemoveReserveInTMP"
                                    name="fk_RemoveReserveInTMP"
                                    value={form.fk_RemoveReserveInTMP}
                                    tabIndex={2}
                                    onChange={handleChange}
                                >
                                    <option value="-1">-Select-</option>
                                    {PSFSElements?.YesNo?.sort((a, b) => a._key - b._key).map((YesNo: PSFSElement) => (
                                        <option key={YesNo._key} value={YesNo._key}>
                                            {YesNo.FriendlyName}
                                        </option>
                                    ))}
                                </select>
                            </span>
                        </div>
                        <div className="form-group mt-3">
                            <label htmlFor="VerifyAppointmentInVCM">
                                Verify appointment dispatches in VCM
                            </label>
                            <span>
                                <select
                                    className="psfs-fields"
                                    id="fk_VerifyAppointmentInVCM"
                                    name="fk_VerifyAppointmentInVCM"
                                    value={form.fk_VerifyAppointmentInVCM}
                                    tabIndex={3}
                                    onChange={handleChange}
                                >
                                    <option value="-1">-Select-</option>
                                    {PSFSElements?.YesNo?.sort((a, b) => a._key - b._key).map((YesNo: PSFSElement) => (
                                        <option key={YesNo._key} value={YesNo._key}>
                                            {YesNo.FriendlyName}
                                        </option>
                                    ))}
                                </select>
                            </span>
                        </div>
                        <div className="form-group mt-3">
                            <label htmlFor="flag_VideoDeviceConsultComments">
                                Video device consult comments<br />
                                added (with serial number) and<br />
                                completed
                            </label>
                            <span>
                                <select
                                    className="psfs-fields"
                                    id="fk_VideoDeviceConsultComments"
                                    name="fk_VideoDeviceConsultComments"
                                    value={form.fk_VideoDeviceConsultComments}
                                    tabIndex={4}
                                    onChange={handleChange}
                                >
                                    <option value="-1">-Select-</option>
                                    {PSFSElements?.YesNo?.sort((a, b) => a._key - b._key).map((YesNo: PSFSElement) => (
                                        <option key={YesNo._key} value={YesNo._key}>
                                            {YesNo.FriendlyName}
                                        </option>
                                    ))}
                                </select>
                            </span>
                        </div>
                        <div className="form-group psfs-buttons mt-10">
                            {!isStepCompleted && (
                                <span>
                                    {PSFSElements?.PSFSStatus && Array.isArray(PSFSElements.PSFSStatus) &&
                                        PSFSElements.PSFSStatus
                                            .filter((status: any) => status.FriendlyName === "Scheduled")
                                            .map((status: any) => (
                                                <span key={status._key}>
                                                    <FoundationsButton
                                                        id={status._key}
                                                        tabIndex={5}
                                                        buttonClasses="psfs-green-button"
                                                        disabled={!isCustomerSite}
                                                        onClick={() => handleStepStatusAndSave("TMPScheduling", status._key, "TwoWeekSetUpCall")}
                                                    >
                                                        {status.FriendlyName}
                                                    </FoundationsButton>
                                                </span>
                                            ))}
                                </span>
                            )}
                            <span>
                                <FoundationsButton
                                    id="-1"
                                    tabIndex={6}
                                    buttonClasses="app-button"
                                    onClick={() => handleSave(false)}
                                >
                                    Save
                                </FoundationsButton>
                            </span>
                            {!isStepCompleted && (
                                <>
                                    <span>
                                        {PSFSElements?.PSFSStatus
                                            .filter((status: any) => status.FriendlyName === "Veteran Declined Appt.")
                                            .map((status: any) => (
                                                <span key={status._key}>
                                                    <FoundationsButton
                                                        id={status._key}
                                                        tabIndex={7}
                                                        disabled={!isCustomerSite}
                                                        buttonClasses="psfs-red-button"
                                                        onClick={() => handleStatusResetAndClose("TMPScheduling", status._key, "TwoWeekSetUpCall")}
                                                    >
                                                        {status.FriendlyName}
                                                    </FoundationsButton>
                                                </span>
                                            ))}
                                    </span>
                                    <span>
                                        {PSFSElements?.PSFSStatus
                                            .filter((status: any) => status.FriendlyName === "Clinically Canceled")
                                            .map((status: any) => (
                                                <span key={status._key}>
                                                    <FoundationsButton
                                                        id={status._key}
                                                        tabIndex={8}
                                                        disabled={!isCustomerSite}
                                                        buttonClasses="psfs-red-button"
                                                        onClick={() => handleStatusResetAndClose("TMPScheduling", status._key, "TwoWeekSetUpCall")}
                                                    >
                                                        {status.FriendlyName}
                                                    </FoundationsButton>
                                                </span>
                                            ))}
                                    </span>
                                </>
                            )}
                        </div>
                    </div>
                    {/* <CommentBox {...commentBoxProps} minHeight="433px" /> */}
                </div>
            </form>
        </>
    );
};

export default TMPScheduling;